"use strict";
/**
 * CONNOX GMBH CONFIDENTIAL
 * ________________________
 *
 * Copyright (c) 2005 - 2022 Connox GmbH, All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property
 * of Connox GmbH and its suppliers, if any. The intellectual and
 * technical concepts contained herein are proprietary to Connox GmbH and
 * its suppliers and may be covered by German Laws and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is
 * strictly forbidden unless prior written permission is obtained from
 * Connox GmbH.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBusControlMessage = void 0;
class TabLogging {
    constructor(broadcastType, sendBroadcast) {
        const stamp = Date.now();
        this.busLog = { broadcastType, ownId: stamp, idSet: new Set([stamp]) };
        this.sendBroadcast = sendBroadcast;
        // on window/tab close/reload send leave intent to others
        window.addEventListener("beforeunload", this.sayBye);
        this.sayHello = this.sayHello.bind(this);
        this.sayBye = this.sayBye.bind(this);
    }
    /**
     * tabLog get function
     */
    get tabLog() {
        return this.busLog;
    }
    /**
     * Sending a join intent to possible other tabs. Do not call in the TabLogging ctor!
     * Has to be called after TabLogging object creation is finished.
     */
    sayHello() {
        const joinIntent = { intent: "join", tabId: this.busLog.ownId };
        this.sendBroadcast(joinIntent);
    }
    /**
     * listens for responses of other tabs, or other join intents, or leave intents
     * @param data
     */
    handleBusControlResponse(data) {
        switch (data.intent) {
            case "join":
                // persist tab id of the one who wants to join
                this.busLog.idSet.add(data.tabId);
                // respond with own timestamp
                const resp = {
                    intent: "response",
                    tabId: this.busLog.ownId,
                };
                this.sendBroadcast(resp);
                break;
            case "response":
                // persist response's tab id
                this.busLog.idSet.add(data.tabId);
                break;
            case "leave":
                this.busLog.idSet.delete(data.tabId);
                break;
            default:
                break;
        }
    }
    sayBye() {
        this.sendBroadcast({
            intent: "leave",
            tabId: this.busLog.ownId,
        });
    }
}
exports.default = TabLogging;
function isBusControlMessage(yell) {
    return yell.intent !== undefined;
}
exports.isBusControlMessage = isBusControlMessage;
